import { api } from './client';

/** ч.821: Oblik+/AI — баланс кредитів tenant'а і використання. */
export interface AiBalance {
  balance: string;
  held: string;
  available: string;
  /** ч.1173: тестовий акаунт — Oblik+/AI без обмежень, кредити не списуються. */
  unlimited?: boolean;
  /** ч.1176: чому без обмежень — тестовий акаунт / акаунт власника платформи /
   *  сам власник платформи в чужому акаунті; null — звичайний облік у межах балансу. */
  unlimited_reason?: 'tester' | 'platform_owner' | 'platform_owner_user' | null;
  credit_usd: number;
  markup: number;
  cost_vat: number;
  last_30d: { calls: number; in_tok: number; out_tok: number; cost: string; charged: string };
  features: Record<string, string>;
}

export const ai = {
  balance: () => api.get<AiBalance>('/ai/balance').then((r) => r.data),
};

export interface PlatformAiCreditRow {
  tenant_id: string;
  name: string;
  plan: string;
  status: string;
  balance: string;
  held: string;
  /** ч.1173: тестовий акаунт — агент за рахунок платформи (списань немає). */
  is_tester?: boolean;
  /** ч.1176: власник акаунта — власник платформи (адмін): теж без обмежень. */
  is_platform_owned?: boolean;
  calls_30d: number;
  cost_usd_30d: string;
  charged_30d: string;
}

export const platformAiCredits = {
  list: () => api.get<{ credit_usd: number; markup: number; cost_vat: number; model: string; items: PlatformAiCreditRow[] }>('/platform/ai-credits').then((r) => r.data),
  topup: (p: { tenant_id: string; credits: number; note?: string | null }) =>
    api.post<{ tenant_id: string; balance: string }>('/platform/ai-credits/topup', p).then((r) => r.data),
  adjust: (p: { tenant_id: string; credits: number; note: string }) =>
    api.post<{ tenant_id: string; balance: string }>('/platform/ai-credits/adjust', p).then((r) => r.data),
  usage: (tenantId: string) =>
    api.get<{ usage: Array<{ created_at: string; feature: string; model: string; input_tokens: number; output_tokens: number; cost_usd: string; charged_credits: string; status: string; organization: string | null }>;
      ledger: Array<{ created_at: string; kind: string; credits: string; note: string | null; hold_id: string | null }> }>(`/platform/ai-credits/${tenantId}/usage`).then((r) => r.data),
};
